<template>
    <div v-if="anyDialogOpen" class="dialog-blur-layer" />
</template>

<script>
import { Capacitor } from '@capacitor/core';
import { mapState } from 'vuex';

export default {
    name: "DialogBackHandler",
    computed: {
        ...mapState(['dialogStack']),
        depth(vm = this) {
            return vm.dialogStack.length
        },
        anyDialogOpen(vm = this) {
            return vm.depth > 0
        },
    },
    created() {
        this._enabled = !Capacitor.isNativePlatform()
        this._fromPop = false
        this._ignorePop = false
        if (this._enabled) {
            this._onPop = this.onPopState.bind(this)
            window.addEventListener('popstate', this._onPop)
            this._removeAfter = this.$router.afterEach(() => {
                this._fromPop = false
                this._ignorePop = false
            })
        }
    },
    beforeDestroy() {
        if (this._onPop) window.removeEventListener('popstate', this._onPop)
        if (this._removeAfter) this._removeAfter()
    },
    methods: {
        onPopState() {
            if (!this._enabled) return
            if (this._ignorePop) {
                this._ignorePop = false
                return
            }
            if (this.depth > 0) {
                const before = this.depth
                this._fromPop = true
                this.$store.commit('popDialog')
                this.$nextTick(() => { this._fromPop = false })
                if (this.depth === before) window.history.pushState({ dlg: before }, '')
            }
        },
    },
    watch: {
        depth(newVal, oldVal) {
            if (!this._enabled) return
            if (newVal > oldVal) {
                for (let i = oldVal; i < newVal; i++) window.history.pushState({ dlg: i + 1 }, '')
            } else if (newVal < oldVal && !this._fromPop) {
                this._ignorePop = true
                window.history.go(-(oldVal - newVal))
            }
        },
    },
}
</script>

<style scoped>
.dialog-blur-layer {
    position: fixed;
    inset: 0;
    z-index: 100;
    pointer-events: none;
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
}
</style>
